import { useQueries } from "@tanstack/react-query";

import { conversationDetailQueryOptions } from "@/api/chat/chat";
import type { IChatConversationDetail } from "@/api/chat/chat.types";

type ConversationId = number | string | undefined;

export interface ConversationDetailRead {
    data: IChatConversationDetail | undefined;
    isError: boolean;
}

const presentIds = (id: ConversationId): string[] =>
    id === undefined || id === "" ? [] : [String(id)];

export const cachedConversationDetailOptions = (id: string) => ({
    ...conversationDetailQueryOptions(id),
    enabled: false,
});

/** Read a conversation's detail, fetching it when stale; a missing id observes no query. */
export function useConversationDetail(
    remoteId: ConversationId
): ConversationDetailRead {
    return useQueries({
        queries: presentIds(remoteId).map((id) =>
            conversationDetailQueryOptions(id)
        ),
        combine: (results) => ({
            data: results[0]?.data,
            isError: results[0]?.isError ?? false,
        }),
    });
}

/** Read a conversation's detail from the cache only; a missing id observes no query. */
export function useCachedConversationDetail(
    remoteId: ConversationId
): IChatConversationDetail | undefined {
    return useQueries({
        queries: presentIds(remoteId).map((id) =>
            cachedConversationDetailOptions(id)
        ),
        combine: (results) => results[0]?.data,
    });
}
